var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaymentHistory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.4166 9.62504V9.16666C17.4166 5.70974 17.4165 3.98122 16.3426 2.90729C15.2687 1.83337 13.5402 1.83337 10.0833 1.83337C6.62643 1.83337 4.89793 1.83343 3.82399 2.90733C2.75008 3.98126 2.75006 5.7097 2.75004 9.1666L2.75 13.2917C2.74997 16.3052 2.74996 17.812 3.58222 18.8261C3.73461 19.0118 3.90487 19.182 4.09056 19.3345C5.10471 20.1667 6.61145 20.1667 9.62495 20.1667",
    stroke: "#423F5A",
    strokeWidth: 1.375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.41675 6.41663H13.7501M6.41675 10.0833H10.0834",
    stroke: "#423F5A",
    strokeWidth: 1.375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 16.9583L15.125 16.4541V14.2083M11 16.0416C11 18.3198 12.8468 20.1666 15.125 20.1666C17.4032 20.1666 19.25 18.3198 19.25 16.0416C19.25 13.7634 17.4032 11.9166 15.125 11.9166C12.8468 11.9166 11 13.7634 11 16.0416Z",
    stroke: "#423F5A",
    strokeWidth: 1.375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentHistory);
export default __webpack_public_path__ + "static/media/payment-history.1dd9598f584ed8183dfe25d114b92ae6.svg";
export { ForwardRef as ReactComponent };